import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20newsroom%20with%20journalists%20working%20on%20laptops%2C%20breaking%20news%20atmosphere%2C%20warm%20lighting%2C%20modern%20office%2C%20editorial%20style%2C%20professional%20yet%20dramatic%20mood%2C%20cinematic%20composition&width=800&height=600&seq=chigua-cta-left&orientation=landscape"
          alt="每日吃瓜编辑团队"
          title="每日吃瓜编辑团队"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        <div className="absolute top-6 left-6">
          <span className="px-3 py-1 bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full whitespace-nowrap">
            加入我们
          </span>
        </div>
        <div className="absolute bottom-6 left-6 right-6">
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-background-50 leading-tight">
            吃瓜
            <br />
            我们是
            <br />
            认真的
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 leading-tight mb-6">
            你有猛料？
            <br />
            我们等你
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed mb-8">
            如果你有独家内幕、一手爆料或任何值得关注的娱乐新闻线索，
            欢迎联系我们。保护爆料人隐私是我们的第一原则，
            你的每一次发声都值得被认真对待。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            联系我们
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}